import { Comment, ThumbUp, Reply, Facebook, Forum } from "@mui/icons-material";
import { Box, Divider } from "@mui/material";
import React from "react";
import { parseURL, prettyTruncate } from "../../../common";
import PostDateElement from "../element/PostDateElement";
import PostImageElement from "../element/PostImageElement";
import PostMetaElement from "../element/PostMetaElement";
import PostTextElement from "../element/PostTextElement";
import PostTitleElement from "../element/PostTitleElement";

function ForumPostCard({post, padding, intent}){
    
    let text = post.post_text;
    text = parseURL(text);
    
    const title = post.title || post.user_screenname;
    return <>
        <Box p={padding}>
            <PostTitleElement title={title} post={post} />
        </Box>

        <PostImageElement post={post}/>
        
        <Box p={padding}>
            <PostTextElement text={prettyTruncate(text,300)} post={post} intent={intent} />
            
            <PostDateElement post={post} />
        </Box>
        <Divider />
        <Box p={padding} display="flex" alignItems={"center"} justifyContent="space-between">
            <Box display="flex" alignItems={"center"} mr={1}>

                <ThumbUp sx={{marginRight: 0.25, marginLeft: 0.75}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_likes}</span>
                <Comment sx={{marginRight: 0.25, marginLeft: 0.75}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_comments}</span>
                <Reply sx={{marginRight: 0.25, marginLeft: 0.75}} fontSize="small"/>
                <span style={{fontSize: 12}}>{post.fb_shares}</span>

            </Box>
            <Forum sx={{color: '#A48AD5'}}/>

        </Box>
        <Divider />
        <Box p={padding}>
            <PostMetaElement post={post} intent={intent} />
        </Box>
    </>
}
export default ForumPostCard;